<template>
  <div>
    <b-row>
      <b-col cols="12" sm="2" class="my-1">
        <b-form-group class="mb-0" label="Per page">
          <b-form-select id="perPageSelect" v-model="perPage"
            :options="pageOptions.map(option => ({ text: option, value: option }))" size="sm" />
        </b-form-group>
      </b-col>

      <b-col cols="12" sm="3" class="my-1">
        <b-form-group label="Search" class="mb-0">
          <b-input-group size="sm">
            <b-form-input id="filterInput" v-model="searchQuery" type="search"
              placeholder="Type to Search" />
            <b-input-group-append>
              <b-button :disabled="!searchQuery" @click="searchQuery = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="my-1">
        <div class="d-flex justify-content-end">
          <b-button variant="primary" to="/content/templates/add">
            <feather-icon icon="PlusIcon" class="mr-50" />
            Add Template
          </b-button>
        </div>
      </b-col>

      <b-col cols="12">
                  <b-alert show variant="warning" v-if="!loading && filteredTemplates.length === 0">
                    <strong>No template available.</strong> Please add one.
                  </b-alert>
        <b-table
        :key="filteredTemplates.length"
        striped
        hover
        responsive
        :items="filteredTemplates.length ? filteredTemplates : []"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        v-if="!loading"
      >
      
      
          <template #cell(actions)="data">
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
              </template>
              <b-dropdown-item @click="prepareViewTemplate(data.item.id)">
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span>View</span>
              </b-dropdown-item>
              <b-dropdown-item @click="prepareEditTemplate(data.item.id)">
                <feather-icon icon="EditIcon" class="mr-50" />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="removeTemplate(data.item.id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

          <template #cell(campaignId)="data">
            {{ getCampaign(data.item.campaignId) }}
          </template>
        </b-table>

        <b-col cols="12" v-if="!loading">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="center" size="sm"
            class="my-0"></b-pagination>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BAlert,
  BCol,
  BFormGroup,
  BFormSelect,
  BTab,
  BTabs,
  BContainer,
  BPagination,
  BInputGroup,
  BFormInput,
  BForm,
  BFormDatepicker,
  BInputGroupAppend,
  VBModal,
  BButton,
  BSpinner,
  BModal,
  BDropdown,
  BFormTextarea,
  BDropdownItem,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

export default {
  components: {
    BTable,
    BAvatar,
    BForm,
    BTab,
    BTabs,
    BModal,
    BBadge,
    BRow,
    BContainer,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    VBModal,
    BFormInput,
    BFormDatepicker,
    BFormTextarea,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BAlert,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      formState: {},
      selectedCampaignId: '',
      id: this.$route.params.id,
      selectedStatus: null,
      changingcomplaint: null,
      showModal: false,
      currentTab: 'All',
      searchQuery: '',
      pageOptions: [3, 5, 10],
      perPage: 5,
      fields: [
  { key: 'name', label: 'Name', sortable: true },
  { key: 'subject', label: 'Subject', sortable: true },
  { key: 'actions', label: 'Actions' }
],
deleting: false,

      currentPage: 1,
      campaigns: [],
      form: {
        firstName: '',
        lastName: '',
        email: '',
        source: '',
        status: 'New',
        campaignId: "",
        isActive: true,
      },
      editForm: {
        leadId: '',
        firstName: '',
        lastName: '',
        email: '',
        source: '',
        status: '',
        isActive: null,
        campaignId: '',
      },
      sources: ['Facebook', 'Instagram', 'LinkedIn', 'Others'],
      sortBy: 'name',
      sortDesc: false,
      optionsCustomer: [],
      submitting: false,
    };
  },
  computed: {
    rows() {
      return this.filteredTemplates.length;
    },

    ...mapGetters("emailtemplate", {
      emailtemplate: "emailtemplate",
      loading: "loading",
    }),

    filteredTemplates() {
    console.log("Templates in Computed Property:", this.emailtemplate); // Debugging
    if (!this.emailtemplate || this.emailtemplate.length === 0) {
      return [];
    }

    let filtered = this.emailtemplate.filter((template) => {
      return (
        !this.searchQuery ||
        Object.values(template)
          .join(" ")
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    });

    if (this.sortBy) {
      filtered = filtered.sort((a, b) => {
        let modifier = this.sortDesc ? -1 : 1;
        if (a[this.sortBy] < b[this.sortBy]) return -1 * modifier;
        if (a[this.sortBy] > b[this.sortBy]) return 1 * modifier;
        return 0;
      });
    }

    return filtered;
  },
  },

  methods: {
    ...mapActions("emailtemplate", ["getContentTemplateAction", "deleteContentTemplateAction"]),

    prepareEditTemplate(id) {
      this.$router.push(`/content/templates/edit/${id}`);
    },

    prepareViewTemplate(id) {
      this.$router.push(`/content/templates/view/${id}`);
    },

    async removeTemplate(id) {
    this.$swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-outline-danger ml-1",
      },
      buttonsStyling: false,
    }).then(async (result) => {
      if (result.value) {
        this.deleting = true;
  this.$swal.fire({
    title: "Processing Delete...",
    text: "Please wait while we remove the template.",
    allowOutsideClick: false,
    didOpen: () => {
      this.$swal.showLoading(); // Show loader inside Swal
    }
  });
        try {
          await this.deleteContentTemplateAction(id);

          this.$swal({
            title: "Deleted!",
            text: "This template has been deleted.",
            icon: "success",
            customClass: { confirmButton: "btn btn-success" },
          });

          // Refresh templates after deletion
          await this.getContentTemplateAction();
        } catch (error) {
          this.$swal({
            title: "Error!",
            text: " Failed! " + (error.response?.data?.message || "Unknown error"),
            icon: "error",
            customClass: { confirmButton: "btn btn-primary" },
            buttonsStyling: false,
          });
        } finally {
          this.deleting = false; // Reset loading state
        }
      } else {
        this.$swal({
          title: "Cancelled",
          text: "Your template hasn't been deleted",
          icon: "error",
          customClass: { confirmButton: "btn btn-success" },
        });
      }
    });
  },
  },

async mounted() {
  try {
    this.$swal.fire({
      title: "Loading Templates...",
      text: "Please wait while we fetch the templates.",
      allowOutsideClick: false,
      didOpen: () => {
        this.$swal.showLoading(); // Show loader inside SweetAlert
      }
    });

    await this.getContentTemplateAction();

    this.$swal.close(); // Close the loader once data is fetched
  } catch (error) {
    console.error("Error loading email templates", error);

    this.$swal.fire({
      title: "Error!",
      text: "Failed to load templates. Please try again.",
      icon: "error",
      customClass: { confirmButton: "btn btn-primary" },
    });
  }
}

};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>

<style scoped>
label {
  font-size: 1.714rem !important;
  font-weight: 500;
  margin-bottom: 0;
}
</style>